module.exports = __webpack_public_path__ + "static/media/talk_now.09b7b210.png";